import { CoreHttpClient } from "@obg/ngx.core";
import { loadScript } from "@obg/ngx.global";
import { PlatformService } from "@obg/ngx.global.evo";
import { Observable, of } from "rxjs";
import { take, tap } from "rxjs/operators";

import { FraudPreventionConfigService } from "./fraud-prevention.config";
import { CustomerFraudToken, FraudPreventionProvider } from "./fraud-prevention.model";
import { FraudPreventionService } from "./fraud-prevention.service";

export class ThreatMetrixFraudPreventionService extends FraudPreventionService {
	private customerFraudToken: CustomerFraudToken | undefined;

	constructor(
		private httpClient: CoreHttpClient,
		private config: FraudPreventionConfigService,
		private platformService: PlatformService
	) {
		super();
	}

	init() {
		if (this.platformService.isServer) {
			return;
		}

		// eslint-disable-next-line rxjs/no-ignored-subscription
		this.getCustomerFraudToken$().pipe(take(1)).subscribe();
	}

	getCustomerFraudToken$(): Observable<CustomerFraudToken> {
		return this.customerFraudToken
			? of(this.customerFraudToken)
			: this.httpClient
					.get<CustomerFraudToken>({
						url: this.config.getThreatMetrixTokenEndpoint(),
					})
					.pipe(tap((threatMetrixToken) => (this.customerFraudToken = threatMetrixToken)));
	}

	loadScript() {
		if (this.platformService.isServer) {
			return;
		}

		this.getCustomerFraudToken$()
			.pipe(take(1))
			// eslint-disable-next-line rxjs/no-ignored-subscription
			.subscribe((customerFraudToken) => {
				loadScript({
					src: customerFraudToken.url,
					id: `fraud-prevention-${FraudPreventionProvider.ThreatMetrix}`,
				});
			});
	}

	unloadScript() {
		// ThreatMetrix script should not be removed because it is strongly recommended to include the script only once
	}
}
